var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchiconblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.575,
    height: 14.575,
    viewBox: "0 0 14.575 14.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M10.3,10.3a6.033,6.033,0,1,1,1.767-4.267A6.015,6.015,0,0,1,10.3,10.3l3.275,3.275Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchiconblue);
export default __webpack_public_path__ + "static/media/Search icon blue.164684b109aeb979ade35d61fbb8c7a9.svg";
export { ForwardRef as ReactComponent };